<template>
  <div id="app">
      <div class="app-view list-view" v-bind:style="{backgroundImage: bgGradient}">
        <div class="jumbotron header">
          <h1>{{title}}</h1>
        </div>
        <VenueList/>
      </div>
    </div>
</template>

<script>
  import VenueList from './components/VenueList'
  import EatMap from './components/EatMap'
  import MapFlip from './components/MapFlip'
  import colorUtils from './util/color'

  export default {
    name: 'app',
    components: {
      VenueList,
      MapFlip,
      EatMap
    },
    data: function() {
      return {
        title: 'eatlist',
        mapVisible: false,
        bgGradient: colorUtils.generateGradient(),
        mapShowing: false
      }
    },
    methods: {
      mapTime() {
        this.mapVisible = !this.mapVisible;
      }
    }
  }
</script>

<style lang="scss">

  html {
    height: 100%;
    width: 100%;
    padding: 0;
    font-family: Roboto, 'sans-serif';
  }

  body {
    // TODO: I think this is causing the weird display issues
    // Recreate: Open page with console open. Close it, see weird white space shit
    height: 100vh;
    width: 100vw;
    background-repeat: no-repeat;
    background-attachment: fixed;
    overflow-x: hidden;
  }

  #autosuggest {
    backface-visibility: hidden;
  }
</style>

<style lang="scss" scoped>

  @import "node_modules/bootstrap/scss/functions";
  @import "node_modules/bootstrap/scss/bootstrap-grid";

  #app {
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    background-attachment: fixed;
    perspective: 600px;
  }

  .eatlist-card {
    width: 100%;
    height: 100%;
    position: relative;
    transition: transform 1s;
    // transition: opacity ease-in-out 1s;
    transform-style: preserve-3d;

    &:not(.is-flipped) {
      .input {
        display: none;
      }
    }

    &.is-flipped {
      transform: rotateY(180deg);
    }
  }

  .app-view {
    position: absolute;
    width: 100%;
    backface-visibility: hidden;
    height: 100vh;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
  }

  .header {
    text-align: center;
    color: white;
    text-shadow: 2px 2px 8px #000;
    background-color: transparent;
    margin-bottom: 0;
  }

  .map-view {
    transform: rotateY( 180deg );
    height: 100vh;
  }

  .jumbotron h1 {
    font-size: 8em;
    font-weight: 100;
    text-transform: uppercase;
  }

  @include media-breakpoint-down(sm) {
    .jumbotron h1 {
      font-size: 5em;
    }
  }

  #map {
    width: 100%;
    height: 100vh;
  }

  ul {
    margin-bottom: 1.5rem;
  }
</style>
